import { atom } from 'recoil';

interface UserState {
  userInfo: UserInfo | null;
  accessToken: string;
}

// @TODO: 결제관련 값들 api와 연결
export const userState = atom<UserState>({
  key: 'userState',
  default: {
    userInfo: null,
    accessToken: '',
  },
});
